import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { findChatByConnectionKeyAndPhoneNumber } from '../readers'

export const updateChat = async (payload: ComponentInfoChatVO, database: Database) => {
  try {
    const chat = await findChatByConnectionKeyAndPhoneNumber(payload.connectionKey, payload.phoneNumber, database)
    if (chat) {
      await chat.updateChat(payload)
    }
  } catch (e) {
    console.error(e)
  }
}
